// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---node-modules-gatsby-plugin-offline-app-shell-js": () => import("/codebuild/output/src032324606/src/github.com/t04glovern/nathanglover-gatsby-portfolio/node_modules/gatsby-plugin-offline/app-shell.js" /* webpackChunkName: "component---node-modules-gatsby-plugin-offline-app-shell-js" */),
  "component---src-pages-404-js": () => import("/codebuild/output/src032324606/src/github.com/t04glovern/nathanglover-gatsby-portfolio/src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-js": () => import("/codebuild/output/src032324606/src/github.com/t04glovern/nathanglover-gatsby-portfolio/src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */)
}

